<template>
  <div class="add-cart-animate-placeholder"></div>
</template>

<script>
export default {
  name: 'CartAnimationPlaceholder',
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.add-cart-animate-placeholder {
  position: fixed;
  z-index: 90;
  width: 113px;
  height: 38px;
  background: var(--coral);
  border-radius: 20px;
  visibility: hidden;
  opacity: 0;
}
</style>
